import React from 'react';
import PropTypes from 'prop-types';
import { Grid, InputAdornment } from '@mui/material';
import { Field } from 'formik';
import { TextField, SwitchField, DateTimePickerField } from 'components/FormFields';
import i18n from 'i18n-js';
import { useSelector } from 'react-redux';

const BasicInformationInputs = ({ values, errors, disabledFields }) => {
  const { localeFormatLower } = useSelector((state) => state.organizations);

  return (
    <Grid item size={12}>
      <Grid container spacing={2} sx={{ maxWidth: '35rem', margin: 'auto' }}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Field
            margin="none"
            name="code"
            disabled={disabledFields}
            component={TextField}
            asyncErrors={errors.code}
            data-cy="promo-code-id-input"
            label={i18n.t('promo_codes.id')}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Field
            min={1}
            step="any"
            type="number"
            margin="none"
            format="price"
            disabled={disabledFields}
            label={i18n.t('promo_codes.credit_amount')}
            name="amount"
            asyncErrors={errors.amount}
            component={TextField}
            required={values.is_enabled}
            startAdornment={
              <InputAdornment position="start" sx={{ mr: -1 }}>
                $
              </InputAdornment>
            }
            data-cy="promo-code-amount-input"
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 12 }}>
          <Field
            margin="none"
            label={i18n.t('common.description')}
            name="description"
            asyncErrors={errors.description}
            component={TextField}
            required={false}
            data-cy="promo-code-description-input"
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Field
            margin="none"
            disabled={disabledFields}
            label={i18n.t('promo_codes.start_time')}
            name="start_time"
            asyncErrors={errors.start_time}
            component={DateTimePickerField}
            showTimeSelect={false}
            dateFormat={localeFormatLower}
            required={values.is_enabled}
            data-cy="promo-code-start-time"
            inputProps={{
              autocomplete: 'off',
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Field
            margin="none"
            label={i18n.t('promo_codes.expiration_time')}
            name="expiration_time"
            asyncErrors={errors.expiration_time}
            component={DateTimePickerField}
            showTimeSelect={false}
            dateFormat={localeFormatLower}
            required={false}
            data-cy="promo-code-expiration-time"
            inputProps={{
              autocomplete: 'off',
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Field
            margin="none"
            required={false}
            name="is_enabled"
            component={SwitchField}
            sx={{
              '& .MuiFormControlLabel-label': { fontWeight: 500, fontSize: 14 },
            }}
            disabled={disabledFields}
            data-cy="promo-code-enabled"
            asyncErrors={errors.is_enabled}
            label={values.is_enabled ? i18n.t('common.enabled') : i18n.t('common.disabled')}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

BasicInformationInputs.propTypes = {
  values: PropTypes.shape({
    is_enabled: PropTypes.bool,
  }),
  errors: PropTypes.shape({
    code: PropTypes.string,
    amount: PropTypes.string,
    description: PropTypes.string,
    start_time: PropTypes.string,
    expiration_time: PropTypes.string,
    is_enabled: PropTypes.string,
  }),
  disabledFields: PropTypes.bool,
};

export { BasicInformationInputs };
